import React, { useEffect, useState } from 'react'
import CourseDetailsComponent, {
  ICourseInfo,
} from '../components/Courses/CourseDetails/CourseDetailsComponent'
import SchoolUserParentContainerComponent from '../containers/SchoolUser/SchoolUserParentContainerComponent'
import InfoAppBar from '../components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import { GetCourseDetails } from '../services/api-requests/api-request'
import Head from 'next/head'
import SchoolMaterialThemeContainer from '../containers/SchoolMaterialThemeContainer'
import ErrorPage from '../components/ErrorPages/ErrorPage'
import SchoolUserPageHead from '../components/SchoolUserPageHead'
import SchoolHomePageNotificationBanner from '@/components/SchoolHomepage/DefaultHomepage/SchoolHomePageNotificationBanner'
import GlobalClientDashboardContainer from 'containers/Global/GlobalClientDashboardContainer'
import { useRouter } from 'next/router'
import { useSchoolContext } from '../context/SchoolContext'
import PageLoadingComponent from '../components/LoadingComponents/PageLoadingComponent'

const CourseDetailsPage = (props: { course_info: ICourseInfo }) => {
  if (!props.course_info?.course_details?._id) {
    return <ErrorPage />
  }

  return (
    <>
      {props.course_info?.school_details && (
        <SchoolUserPageHead schoolDetails={props.course_info?.school_details} />
      )}
      <Head>
        <title>
          {props.course_info?.course_details?.name} -{' '}
          {props.course_info?.course_details?.short_description}
        </title>
        <meta
          name="description"
          content={props?.course_info?.course_details?.short_description}
        />
        <meta
          name="keywords"
          content={`schools, https://pledre.com/schools, education, pledre.com, ${props.course_info?.school_details?.school_url}.pledre.school`}
        />
        <link
          rel="shortcut icon"
          href={props.course_info?.school_details.logo}
        />
        <meta
          property="og:title"
          content={props.course_info?.course_details?.name}
        />
        <meta
          property="og:url"
          content={`${
            props.course_info?.school_details
              ? props.course_info?.school_details?.school_url
              : ''
          }.pledre.school`}
        />
        <meta
          property="og:image"
          content={props.course_info?.school_details?.logo}
        />
        <meta
          property="og:image:secure_url"
          content={props.course_info?.school_details.logo}
        />
      </Head>
      <GlobalClientDashboardContainer>
        <SchoolMaterialThemeContainer
          schoolDetails={props.course_info?.school_details}
        >
          <>
            <SchoolUserParentContainerComponent
              school_id={props.course_info?.school_details._id}
              fb_pixel_id={props.course_info?.school_details?.fb_pixels_id}
            >
              <InfoAppBar
                school_details={props.course_info?.school_details as any}
                defaultStyle={
                  {
                    // marginTop: "-5px",
                    // backgroundColor: "#131313"
                  }
                }
                // appbarStyle={{ boxShadow: "none" }}
                // linkStyle={{ color: "#fafafaa1" }}
              />
              <SchoolHomePageNotificationBanner
                schoolDetails={props.course_info?.school_details as any}
              />
              <div
                style={{
                  width: '100%',
                }}
              >
                <CourseDetailsComponent
                  schoolDetailsFromCourse={props.course_info?.school_details}
                  courseId={props.course_info?.course_details?._id}
                  courseInfo={props.course_info}
                />
              </div>
            </SchoolUserParentContainerComponent>
          </>
        </SchoolMaterialThemeContainer>
      </GlobalClientDashboardContainer>
    </>
  )
}

const CourseDetailsWrapper: React.FC<any> = props => {
  const router = useRouter()
  const {
    loading: schoolLoading,
    error: schoolError,
    schoolDetails: contextSchoolDetails,
  } = useSchoolContext()
  const [loading, setLoading] = useState(false)
  const [courseInfo, setCourseInfo] = useState<any>(props?.course_info || null)

  useEffect(() => {
    setCourseInfo(props?.course_info || null)
  }, [props?.course_info])

  useEffect(() => {
    const courseQuery = router.query.course_id
    const courseId =
      typeof courseQuery === 'string'
        ? courseQuery
        : Array.isArray(courseQuery)
        ? courseQuery[0]
        : undefined

    if (props?.course_info || !courseId || courseInfo) {
      return
    }

    if (schoolLoading) {
      return
    }

    const schoolId = contextSchoolDetails?._id

    if (!schoolId) {
      if (schoolError) {
        setLoading(false)
      }
      return
    }

    let cancelled = false
    const loadCourse = async () => {
      setLoading(true)
      try {
        const courseRes = await GetCourseDetails(courseId, schoolId)
        if (cancelled) return
        const responseData = courseRes?.data?.data
        if (responseData) {
          setCourseInfo({
            course_slug: courseId,
            course_id: responseData.course_details._id,
            course_details: responseData.course_details,
            course_lesson_content: responseData.course_lesson_content,
            mirror_course_lesson_content:
              responseData.mirror_course_lesson_content || null,
            school_details: responseData.school_details,
            payment_plans: responseData.payment_plans,
          })
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading course details client-side', err)
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    void loadCourse()

    return () => {
      cancelled = true
    }
  }, [
    props?.course_info,
    router.query.course_id,
    schoolLoading,
    contextSchoolDetails?._id,
    schoolError,
    courseInfo,
  ])

  if (!courseInfo && loading) {
    return <PageLoadingComponent />
  }
  if (!courseInfo) return <ErrorPage />

  return <CourseDetailsPage course_info={courseInfo} />
}

export default CourseDetailsWrapper
